import React from 'react';
import moment from 'moment';
import './Timeline.css';

const Timeline = ({
  checkin,
  checkout,
  breaks,
  status,
  leaveType,
  totalHours,
  formatHoursToHM
}) => {
  const renderStatusBox = (text, bgClass = 'absent') => (
    <div className={`timeline-container status-container ${bgClass}`}>
      <span className="status-indicator">{text}</span>
      <span className="total-hours">{formatHoursToHM(totalHours) || 'N/A'}</span>
    </div>
  );

  if (status === 'Requested') {
    return renderStatusBox('OD Requested', 'requested');
  }

  if (status === 'OD' || (status === 'Absent' && leaveType === 'OD')) {
    return renderStatusBox('OD', 'od');
  }

  if (status === 'Leave' || (status === 'Absent' && leaveType && leaveType !== 'OD')) {
    return renderStatusBox(leaveType || 'Leave', 'leave');
  }

  if (status === 'LWP' || (status === 'Absent' && !leaveType)) {
    return renderStatusBox('AB', 'absent');
  }

  if (status === 'Present' && checkin) {
    const checkinMoment = moment(checkin);
    const checkoutMoment = checkout ? moment(checkout) : moment();
    const totalDuration = checkoutMoment.diff(checkinMoment, 'minutes');

    if (totalDuration <= 0) {
      return <div className="timeline-container"><span className="total-hours">Invalid</span></div>;
    }

    const allSegments = [];
    let currentStart = checkinMoment.clone();

    const completedBreaks = (breaks || []).filter(b => b.start && b.end);
    const sortedBreaks = completedBreaks.sort((a, b) => moment(a.start).diff(moment(b.start)));

    sortedBreaks.forEach((b) => {
      const breakStart = moment(b.start);
      const breakEnd = moment(b.end);

      const workDuration = breakStart.diff(currentStart, 'minutes');
      if (workDuration > 0) {
        allSegments.push({ type: 'work', duration: workDuration, start: currentStart, end: breakStart });
      }

      const breakDuration = breakEnd.diff(breakStart, 'minutes');
      if (breakDuration > 0) {
        allSegments.push({ type: 'break', duration: breakDuration, start: breakStart, end: breakEnd });
      }

      currentStart = breakEnd.clone();
    });

    const finalWorkDuration = checkoutMoment.diff(currentStart, 'minutes');
    if (finalWorkDuration > 0) {
      allSegments.push({ type: 'work', duration: finalWorkDuration, start: currentStart, end: checkoutMoment });
    }

    if (allSegments.length === 0) {
      allSegments.push({ type: 'work', duration: totalDuration, start: checkinMoment, end: checkoutMoment });
    }

    return (
      <div className="timeline-container">
        <div className="timeline-bar-wrapper">
          <div className="timeline-bar">
            {allSegments.map((seg, idx) => (
              <React.Fragment key={idx}>
                <div
                  className={`timeline-segment ${seg.type}`}
                  style={{ flexGrow: seg.duration }}
                />
                {seg.type === 'break' && (
                  <div
                    className="break-label"
                    style={{
                      left: `${(seg.start.diff(checkinMoment, 'minutes') / totalDuration) * 105}%`
                    }}
                  >
                    {seg.duration}m
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
          <div className="timeline-labels">
            <span className="time-label checkin-label">{checkinMoment.format('HH:mm')}</span>
            <span className="time-label checkout-label">{checkoutMoment.format('HH:mm')}</span>
          </div>
        </div>
        <span className="total-hours">{formatHoursToHM(totalHours)}</span>
      </div>
    );
  }
  return renderStatusBox('—', 'absent');
};

export default Timeline;
